export function message<P>(message: string | ((param: P) => string), param: P) {
    return typeof message === 'function' ? message(param) : message;
}
